import { IFilter } from "../models";
import { BrowseActionTypes } from "../models/browseActions";
import { SET_FILTERS } from "../types";

export default (filters: IFilter[]): BrowseActionTypes => ({
    type: SET_FILTERS,
    payload: filters,
});
